
















































































































import QuoteStateMixin from '@/mixins/quoteState';
import auth from '@/mixins/auth';
import { mapActions, mapGetters } from 'vuex';

import { ErrorManager } from '@/models/error';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import QuoteDocumentBuilderDialog from '@/components/quotes/QuoteDocumentBuilderDialog.vue';

import { IQuoteData, QuoteFieldError, QuoteState } from '@/models';
import QuoteOrderFormDialog from '../QuoteOrderFormDialog.vue';
import mixins from '@/utils/mixins';
import QuoteCreateSalesOpportunityListItem from '../QuoteCreateSalesOpportunityListItem.vue';
import QuoteGenerateOrderReviewListItem from '../QuoteGenerateOrderReviewListItem.vue';

const baseMixins = mixins(QuoteStateMixin, auth);

type QuoteCustomerAwardedStateCardOptions = InstanceType<typeof baseMixins>;
interface Options extends QuoteCustomerAwardedStateCardOptions {
  $refs: QuoteCustomerAwardedStateCardOptions['$refs'] & {
    quoteOrderFormDialog: InstanceType<typeof QuoteOrderFormDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    components: {
      ErrorAlert,
      QuoteOrderFormDialog,
      QuoteDocumentBuilderDialog,
      QuoteCreateSalesOpportunityListItem,
      QuoteGenerateOrderReviewListItem
    },
    name: 'QuoteCustomerAwardedStateCard',

    computed: {
      ...mapGetters({
        getQuoteById: 'quote/getQuoteById'
      }),

      getColor(): string {
        return 'done';
      },

      getIcon(): string {
        return 'mdi-check-outline';
      },

      getString(): string {
        return 'Customer accepted/Awaiting Order Processing';
      }
    },

    data: () => ({
      loading: false,
      rfqDateValue: null as string | null,

      quoteHeaderRules: [(v: any) => !!v || 'This field is required'],

      fieldError: new QuoteFieldError()
    }),

    methods: {
      ...mapActions({
        createQuoteRevision: 'quote/createQuoteRevision'
      }),

      createOrder() {
        const dialog = this.$refs.quoteOrderFormDialog;
        dialog.open(this.quote);
      },

      orderCreated(state: QuoteState) {
        this.createSnack({
          color: 'success darken-1',
          type: 'success',
          right: true,
          useBtn: false,
          msg: 'Created order successfully',
          btnText: 'Ok'
        });
        this.$emit('state-changed:quote', {
          number: this.quote.number,
          revision: this.quote.revision,
          state: state
        });
      },

      async createRevision(quoteData: IQuoteData) {
        this.clearAllErrors();
        this.loading = true;

        return this.createNewQuoteRevision(quoteData).catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
            if (QuoteFieldError.isQuoteFieldError(error.response.data)) {
              this.fieldError = new QuoteFieldError(error.response.data);
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
          //because the page is reloaded there's no need to reset loading flag on finally
          this.loading = false;
        });
      }
    }
  });
